import { CSSObject, styled } from '../styled';
import { Colors } from '../theme';

export const AutocompleteStyled = styled('div')<{
  readOnly?: boolean;
  disabled?: boolean;
}>(({ theme, readOnly, disabled }) => ({
  '& label': {
    color: theme.palette.inputLabel,
    ...theme.typography.captionSemiBold,
    transform: 'none',
  },

  '& div.MuiInputBase-formControl input.MuiInput-input::placeholder': {
    opacity: '1 !important',
  },

  '& .MuiInputBase-root': {
    flexWrap: 'nowrap !important',
    paddingRight: '12px !important',
  },

  '& .MuiAutocomplete-endAdornment': {
    position: 'static',
    display: 'flex',
    transform: 'none',
    alignItems: 'center',
    gap: 4,
  },

  '& .autocomplete-tag': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textWrap: 'nowrap',
    pointerEvents: readOnly || disabled ? 'all' : 'none',
    ...theme.typography.bodyMedium,
  } as CSSObject,

  '.MuiAutocomplete-clearIndicator': {
    color: Colors.black,
  },
  '.MuiIconButton-root': {
    transition: theme.transitions.create('color'),

    '&:hover svg': {
      color: Colors.hover,
    },
  },
}));
